import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Enquiry.css';

const Enquiry = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div id='contact' className="enquiry-main">
      <div className="enquiry-container">
        
        {/* LEFT SIDE IMAGE */}
        <div className="enquiry-image-side" data-aos="fade-right">
          <div className="overlay">
            <h1 className='fontgeorgio'>Premium Car Rentals</h1>
            <p className='fontroboto'>Book with ease. Ride in comfort.</p>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="enquiry-form-side" data-aos="fade-left">
          <div className="form-wrapper">
            <h2 className='fontgeorgio'>Enquiry Form</h2>
            <form>
              <input type="text" placeholder="Full Name" required />
              <input type="email" placeholder="Email Address" required />
              <input type="tel" placeholder="Phone Number" required />
              <select required>
                <option value="">Select Rental Hours</option>
                <option>1 Hour</option>
                <option>2 Hours</option>
                <option>4 Hours</option>
                <option>8 Hours</option>
                <option>Full Day</option>
              </select>
              <select required>
                <option value="">No. of Passengers</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4+</option>
              </select>
              <input type="text" placeholder="Pickup Location" required />
              <input type="text" placeholder="Drop-off Location" required />
              <input type="date" required />
              <button type="submit">Submit Enquiry</button>
            </form>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Enquiry;
